import postApiService from 'modules/api/services/post'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'
import setItemLocalStorageUtil from 'modules/local-storage/set-item/index.js'
import { logUtil } from 'packages/src'
import {
  NEWSLETTER_KEY,
  NEWSLETTER_SUBMIT_STATUS
} from 'components/Newsletter/constants/index.js'

const handleFormSubmitNewsletterUtil = async (params) => {
  logUtil('Newsletter#handleFormSubmit').debug('params=', params)
  const {
    formik,
    values
  } = params
  try {
    logUtil('Newsletter#handleFormSubmit').debug('submitting values=', values)
    formik.setSubmitting(true)

    setItemLocalStorageUtil(NEWSLETTER_KEY.EMAIL, values[NEWSLETTER_KEY.EMAIL])

    await postApiService(
      `${getApiServiceUrlEnvironmentUtil()}/functions/join-newsletter`,
      values
    )

    params.setSubmitStatus(NEWSLETTER_SUBMIT_STATUS.SUCCESS)
  } catch (error) {
    logUtil('Newsletter#handleFormSubmit').error('error=', error)
    params.setSubmitStatus(NEWSLETTER_SUBMIT_STATUS.FAILURE)
  }

  formik.setSubmitting(false)
}

export default handleFormSubmitNewsletterUtil
